__turbopack_context__.v({
  "header": "FeedItem-module-scss-module__FovjHG__header",
  "meta": "FeedItem-module-scss-module__FovjHG__meta",
  "title": "FeedItem-module-scss-module__FovjHG__title",
  "withVerticalPadding": "FeedItem-module-scss-module__FovjHG__withVerticalPadding",
  "wrapper": "FeedItem-module-scss-module__FovjHG__wrapper",
});
